import { render, staticRenderFns } from "./TrusteeToTrusteeTransferFinish.vue?vue&type=template&id=5d03dfa4&scoped=true"
import script from "./TrusteeToTrusteeTransferFinish.vue?vue&type=script&lang=ts"
export * from "./TrusteeToTrusteeTransferFinish.vue?vue&type=script&lang=ts"
import style0 from "./TrusteeToTrusteeTransferFinish.vue?vue&type=style&index=0&id=5d03dfa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d03dfa4",
  null
  
)

export default component.exports